export default __webpack_public_path__ + "static/media/linkedin.5eff65b2.svg";